import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const Heading1 = ({ node }: RichTextContentProps) => {
  return (
    <h1>
      <RichTextContent node={node} />
    </h1>
  );
};

export default Heading1;
